/**
 * Site Feasibility record / template / report status — SSOT.
 */

import { createStatusHelpers } from "./statusHelpers";

export const FEASIBILITY_STATUS = {
  DRAFT: "Draft",
  SENT: "Sent",
  SUBMITTED: "Submitted",
  UPLOADED: "Uploaded",
  ELIGIBLE: "Eligible",
  NOT_ELIGIBLE: "Not Eligible",
  SUPERSEDED: "Superseded",
} as const;

export type FeasibilityStatus =
  (typeof FEASIBILITY_STATUS)[keyof typeof FEASIBILITY_STATUS];

const recordHelpers = createStatusHelpers(
  FEASIBILITY_STATUS,
  FEASIBILITY_STATUS.DRAFT,
);

export const FEASIBILITY_STATUS_VALUES = recordHelpers.VALUES;
export const tryNormalizeFeasibilityStatus = recordHelpers.tryNormalize;
export const normalizeFeasibilityStatus = recordHelpers.normalize;
export const isFeasibilityStatus = recordHelpers.isStatus;
export const isAnyFeasibilityStatus = recordHelpers.isAnyStatus;

export const FEASIBILITY_TEMPLATE_STATUS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUPERSEDED: "Superseded",
} as const;

export type FeasibilityTemplateStatus =
  (typeof FEASIBILITY_TEMPLATE_STATUS)[keyof typeof FEASIBILITY_TEMPLATE_STATUS];

const templateHelpers = createStatusHelpers(
  FEASIBILITY_TEMPLATE_STATUS,
  FEASIBILITY_TEMPLATE_STATUS.DRAFT,
);

export const FEASIBILITY_TEMPLATE_STATUS_VALUES = templateHelpers.VALUES;
export const tryNormalizeFeasibilityTemplateStatus =
  templateHelpers.tryNormalize;
export const normalizeFeasibilityTemplateStatus = templateHelpers.normalize;
export const isFeasibilityTemplateStatus = templateHelpers.isStatus;
export const isAnyFeasibilityTemplateStatus = templateHelpers.isAnyStatus;

export const FEASIBILITY_REPORT_STATUS = {
  GENERATED: "Generated",
  FILED_TO_ETMF: "Filed to eTMF",
  REJECTED_IN_ETMF: "Rejected in eTMF",
  SUPERSEDED: "Superseded",
} as const;

export type FeasibilityReportStatus =
  (typeof FEASIBILITY_REPORT_STATUS)[keyof typeof FEASIBILITY_REPORT_STATUS];

const reportHelpers = createStatusHelpers(
  FEASIBILITY_REPORT_STATUS,
  FEASIBILITY_REPORT_STATUS.GENERATED,
);

export const FEASIBILITY_REPORT_STATUS_VALUES = reportHelpers.VALUES;
export const tryNormalizeFeasibilityReportStatus = reportHelpers.tryNormalize;
export const normalizeFeasibilityReportStatus = reportHelpers.normalize;
export const isFeasibilityReportStatus = reportHelpers.isStatus;
export const isAnyFeasibilityReportStatus = reportHelpers.isAnyStatus;
